import axios from 'axios';
import { jwtDecode } from 'jwt-decode';

const API_URL = '/api';// Backend URL

// Function to get user role from the server
export const fetchUserRole = async () => {
  try {
    const token = localStorage.getItem('token');
    if (!token) return null;
    
    const response = await axios.get(`${API_URL}/user/role`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    
    if (response.data.role) {
      localStorage.setItem('userRole', response.data.role);
      return response.data.role;
    }
    return null;
  } catch (error) {
    console.error('Error fetching user role:', error);
    return null;
  }
};

export const login = async (username, password) => {
  try {
    const formData = new URLSearchParams();
    formData.append('username', username);
    formData.append('password', password);
    
    // First, get the token
    const response = await axios.post(`${API_URL}/token`, formData, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });
    
    if (response.data.access_token) {
      const token = response.data.access_token;
      // Save the token to localStorage
      localStorage.setItem('token', token);
      
      // Decode token to get basic info
      const decodedToken = jwtDecode(token);

      
      // Save username from token
      if (decodedToken.sub) localStorage.setItem('username', decodedToken.sub);
      if (decodedToken.exp) localStorage.setItem('tokenExp', decodedToken.exp);
      
      // Fetch user role from the server
      const userRole = await fetchUserRole();
      
      return {
        ...response.data,
        user: {
          username: decodedToken.sub,
          role: userRole,
          // Add any other user properties you need
        }
      };
    }
    
    return null;
  } catch (error) {
    console.error('Login error:', error);
    throw error;
  }
};

export const getAuthToken = () => {
  return localStorage.getItem('token');
};

export const isAuthenticated = () => {
  return !!getAuthToken();
};

export const logout = () => {
  localStorage.removeItem('token');
};
